import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=07120caa&scoped=true&lang=pug&"
import script from "./FormGroup.vue?vue&type=script&lang=js&"
export * from "./FormGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormGroup.vue?vue&type=style&index=0&id=07120caa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07120caa",
  null
  
)

export default component.exports